export type AppRole = 'admin' | 'manager' | 'user' | null | undefined;

export type AppCapability =
  | 'canAccessDemoMode'
  | 'canManageClients'
  | 'canViewBusinessDev'
  | 'canManageAgreements'
  | 'canViewFinancials'
  | 'canViewCrmFinanceIntegrations'
  | 'canManageWorkspaceIntegrations'
  | 'canViewSecuritySettings'
  | 'canManageSlaSettings'
  | 'canViewTeamEmailReviews';

export type Capabilities = Record<AppCapability, boolean>;

const NONE_CAPABILITIES: Capabilities = {
  canAccessDemoMode: false,
  canManageClients: false,
  canViewBusinessDev: false,
  canManageAgreements: false,
  canViewFinancials: false,
  canViewCrmFinanceIntegrations: false,
  canManageWorkspaceIntegrations: false,
  canViewSecuritySettings: false,
  canManageSlaSettings: false,
  canViewTeamEmailReviews: false,
};

const MANAGER_CAPABILITIES: Capabilities = {
  ...NONE_CAPABILITIES,
  canAccessDemoMode: true,
  canManageClients: true,
  canViewBusinessDev: true,
  canManageAgreements: true,
  canViewFinancials: true,
  canViewCrmFinanceIntegrations: true,
  canManageSlaSettings: true,
  canViewTeamEmailReviews: true,
};

const ADMIN_CAPABILITIES: Capabilities = {
  ...MANAGER_CAPABILITIES,
  canManageWorkspaceIntegrations: true,
  canViewSecuritySettings: true,
};

const ROLE_TO_CAPABILITIES: Record<Exclude<AppRole, null | undefined>, Capabilities> = {
  admin: ADMIN_CAPABILITIES,
  manager: MANAGER_CAPABILITIES,
  user: NONE_CAPABILITIES,
};

export function getCapabilitiesForRole(role: AppRole): Capabilities {
  if (!role) return NONE_CAPABILITIES;
  return ROLE_TO_CAPABILITIES[role] ?? NONE_CAPABILITIES;
}

export function canManageWorkspaceIntegrationsForRole(role: AppRole): boolean {
  return getCapabilitiesForRole(role).canManageWorkspaceIntegrations;
}
